var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { Urls } from '../../../enums/urls';
var FooterComponent = /** @class */ (function () {
    function FooterComponent() {
        this.viewModel = {
            termsAndConditions: {
                url: Urls.TermsAndConditions,
                text: 'Terms & Conditions'
            },
            policies: {
                url: Urls.Policies,
                text: "powered by OneFile Eportfolio \u00A9 Onefile Ltd, 2005 - " + new Date().getFullYear() + " | All Rights Reserved"
            }
        };
    }
    FooterComponent = __decorate([
        Component({
            selector: 'app-footer',
            template: require('./footer.component.html'),
            styles: [require('./footer.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], FooterComponent);
    return FooterComponent;
}());
export { FooterComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9vdGVyLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZvb3Rlci5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUcxQyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0scUJBQXFCLENBQUM7QUFPM0M7SUFFSTtRQUNJLElBQUksQ0FBQyxTQUFTLEdBQUc7WUFDYixrQkFBa0IsRUFBRTtnQkFDaEIsR0FBRyxFQUFFLElBQUksQ0FBQyxrQkFBa0I7Z0JBQzVCLElBQUksRUFBRSxvQkFBb0I7YUFDN0I7WUFDRCxRQUFRLEVBQUU7Z0JBQ04sR0FBRyxFQUFFLElBQUksQ0FBQyxRQUFRO2dCQUNsQixJQUFJLEVBQUUsOERBQXVELElBQUksSUFBSSxFQUFFLENBQUMsV0FBVyxFQUFFLDJCQUF3QjthQUNoSDtTQUNKLENBQUM7SUFDTixDQUFDO0lBYlEsZUFBZTtRQUwzQixTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsWUFBWTtZQUN0QixRQUFRLEVBQUUsT0FBTyxDQUFDLHlCQUF5QixDQUFDO1lBQzVDLE1BQU0sRUFBRSxDQUFDLE9BQU8sQ0FBQyx5QkFBeUIsQ0FBQyxDQUFDO1NBQy9DLENBQUM7O09BQ1csZUFBZSxDQWMzQjtJQUFELHNCQUFDO0NBQUEsQUFkRCxJQWNDO1NBZFksZUFBZSJ9